import { React, Fragment, useEffect } from 'react';
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  Navigate,
} from 'react-router-dom';
import Homepage from './homepage/index';
import DynamicPage from './homepage/Dynamic-Page';
import News from './homepage/News';
import Statistics from './homepage/Statistics';
import DetailNews from './homepage/DetailNews';
import Contact from './homepage/Contact';
import Legislation from './homepage/Legislation';
import FixedDivs from '../component/FixedDivs/FixedDivs';
import Faq from './homepage/Faq';
import DangerProducts from './homepage/DangerProducts';
import DetailDangerProduct from './homepage/DetailDangerProduct';
import AboutDangerProducts from './homepage/AboutDangerProducts';
import { Layout } from './homepage/Layout';
import PublicInfo from './homepage/PublicInfo';
import { PenaltyPage } from './homepage/PenaltyPage';
import PenaltyDetail from './homepage/PenaltyDetail';

const Index = (props) => {
  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };
  return (
    <Fragment>
      <BrowserRouter forceRefresh>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route exact='true' path='/' element={<Homepage />}></Route>
            <Route
              exact='true'
              path='/dangerproducts'
              element={<DangerProducts />}
            ></Route>
            <Route
              exact='true'
              path='/dangerproducts/detail/:id'
              element={<DetailDangerProduct />}
            ></Route>
            <Route
              exact='true'
              path='/aboutdangerproducts'
              element={<AboutDangerProducts />}
            ></Route>
            <Route
              exact='true'
              path='/publicinfo'
              element={<PublicInfo />}
            ></Route>

            <Route
              exact='true'
              path='/page/:menu_id'
              element={<DynamicPage />}
            ></Route>

            <Route exact='true' path='/news' element={<News />}></Route>
            <Route exact='true' path='/contact' element={<Contact />}></Route>

            <Route
              exact='true'
              path='/statistics'
              element={<Statistics />}
            ></Route>
            <Route
              exact='true'
              path='/news/detail/:id'
              element={<DetailNews />}
            ></Route>

            <Route exact path='/faq' element={<Faq />}></Route>
            <Route exact path='/legislation' element={<Legislation />}></Route>
            <Route exact path='/penalty' element={<PenaltyPage />}></Route>
            <Route
              exact
              path='/penalty/detail/:id'
              element={<PenaltyDetail />}
            ></Route>
            <Route path='*' element={<Navigate to='/' replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <FixedDivs />
    </Fragment>
  );
};

export default Index;
